import { createAsyncActionTypes } from 'conversations-async-data/async-action/createAsyncActionTypes';
export const FETCH_ASSOCIATIONS = createAsyncActionTypes('FETCH_ASSOCIATIONS');